import { render, staticRenderFns } from "./StellarList.vue?vue&type=template&id=18f5ca40&scoped=true"
import script from "./StellarList.vue?vue&type=script&lang=js"
export * from "./StellarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5ca40",
  null
  
)

export default component.exports